/* eslint-disable no-throw-literal */
import {
  GET_COMPANY_NOTICE_LIST,
  GET_UNREAD_COMPANY_NOTICE_EXIST,
  GET_COMPANY_NOTICE_DETAIL,
  COMPANY_NOTICE_ALREADY_READ_UPDATE
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_COMPANY_NOTICE_LIST] ({dispatch}, params) {
      const res = await dispatch('apiGet', {url: '/asovi/company_notices/', data: params.data})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_UNREAD_COMPANY_NOTICE_EXIST] ({dispatch}, params) {
      const res = await dispatch('apiGet', {url: '/asovi/company_notices/get_unread_company_notice_exist', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_COMPANY_NOTICE_DETAIL] ({dispatch}, params) {
      const res = await dispatch('apiGet', {url: '/asovi/company_notices/' + params.id})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [COMPANY_NOTICE_ALREADY_READ_UPDATE] ({dispatch}, params) {
      let res = await dispatch('apiPatch', {url: '/asovi/company_notice_read_managers/' + params.id})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/company-notice.js